module.exports = __webpack_public_path__ + "img/any-bg1.7ba21f86.png";